import { useEffect, useState } from 'react';
import { api, ErroApi, guardarContexto, guardarToken } from '../api';
import { Carregando, Erro } from '../componentes/ui';

/**
 * Entrada pela Central da Atendi9: o link traz o token de uso unico no
 * fragmento (#t=), que o navegador nao manda ao servidor nem grava em log.
 */
export function Central() {
  const [erro, setErro] = useState('');

  useEffect(() => {
    const t = new URLSearchParams(window.location.hash.slice(1)).get('t') || '';
    window.history.replaceState(null, '', '/central');
    if (!t) {
      setErro('Este link não tem a chave de acesso. Abra o portal de novo pela Central.');
      return;
    }
    api.entrarCentral(t)
      .then((r) => {
        guardarToken(r.token);
        guardarContexto({
          tipo: 'empresa', id: r.empresaId, rotulo: 'Empresa aberta pela Central', detalhe: 'Acesso pela Central da Atendi9',
        });
        window.location.replace('/painel/documentos');
      })
      .catch((e) => setErro(e instanceof ErroApi ? e.message : 'Não consegui abrir o portal.'));
  }, []);

  return (
    <div className="center-screen">
      {erro ? <Erro>{erro}</Erro> : <Carregando texto="Abrindo a empresa…" />}
    </div>
  );
}
